<!--@formatter:off-->
<i18n src="./locale.json"></i18n>
<!--@formatter:on-->

<style lang="sass" scoped>
@import 'component'
</style>

<template lang="pug">

  form(v-on:submit.prevent="handleSubmit")

    c-form-error(v-bind:message="$t(responseErrorMessage)")

    // Password
    div(v-bind:class="$v.password.$error ? 'is-invalid' :'is-dirty'")
      div.form-group.input-password
        input(
          v-model="password"
          
          type="password"
          autocomplete="new-password"
          
          :placeholder="$t('input_password')"
          :class="checkNotSamePass() ? 'is-invalid' :'is-dirty'"

          @input="$v.password.$touch()"
        )
        label 
          // Больше XX знаков, включая буквы и цифры
      div.form-group.input-password
        input(
          v-model="repeatPassword"

          type="password"
          autocomplete="new-password"

          :placeholder="$t('input_repeat_password')"
          :class="$v.password.$error && checkNotSamePass() ? 'is-invalid' :'is-dirty'"
        )

      div.invalid-feedback(v-if="!$v.password.required") {{ $t('error_password_required') }}
      div.invalid-feedback(v-else-if="checkNotSamePass()") {{ $t('error_password_not_same') }}
      div.invalid-feedback(v-else-if="!$v.password.minLength") {{ $t('error_password_min_length', { min: $v.password.$params.minLength.min }) }}

    c-form-submit(v-bind:isDisabled="isInvalidRequestParams()" v-bind:isLoading="requestBeingProcessed") {{ $t('btn_submit') }}

</template>

<script>
import { minLength, required, sameAs } from 'vuelidate/lib/validators';

import * as responseCodes from 'classes/response-codes';
import cFormError from 'components/c-form/c-form-error/component';
import cInputPhone from 'components/c-form/c-form-input-phone/component';
import cFormSubmit from 'components/c-form/c-form-submit/component';
import mFormSubmit from 'mixins/formSubmit';
import * as types from 'store/mutation-types';

export default {
  name: 'FormForgotPassword',
  mixins: [mFormSubmit],

  components: {
    cInputPhone,
    cFormError,
    cFormSubmit,
  },

  data() {
    return {};
  },

  validations() {
    return {
      password: {
        required,
        minLength: minLength(4),
        sameAsPassword: sameAs('repeatPassword'),
      },
    };
  },

  computed: {
    password: {
      get() {
        return this.$store.state.registration.password;
      },
      set(value) {
        this.$store.commit(`registration/${types.SET_PASSWORD}`, value);
      },
    },
    repeatPassword: {
      get() {
        return this.$store.state.registration.repeatPassword;
      },
      set(value) {
        this.$store.commit(`registration/${types.SET_REPEAT_PASSWORD}`, value);
      },
    },
    phoneCode: {
      get() {
        return this.$store.state.registration.phoneCode;
      },
      set(val) {
        this.$store.commit(`registration/${types.SET_PHONE_CODE}`, val.replace(/\D/g, ''));
      },
    },
    phoneNumber: {
      get() {
        return this.$store.state.registration.phoneNumber;
      },
      set(val) {
        this.$store.commit(`registration/${types.SET_PHONE_NUMBER}`, val.replace(/\D/g, ''));
      },
    },
    smsCode() {
      return this.$store.state.registration.smsCode;
    },
    smsCodeValid() {
      return this.$store.state.registration.smsCodeValid;
    },
  },

  methods: {
    checkNotSamePass() {
      if (!this.repeatPassword) {
        return false;
      }

      return !this.$v.password.sameAsPassword;
    },

    handleRequestUrl() {
      return '/password/update-password';
    },

    handleRequestParams() {
      return {
        phone_code: this.phoneCode,
        phone_number: this.phoneNumber,
        password: this.password,
        security_code: this.smsCode,
      };
    },

    handleResponse(response) {
      switch (this.getResponceStatusCode(response)) {
        // Номер телефона подтвержден, нужно восстановить пароль
        case responseCodes.RESPONSE_PASSWORD_WAS_UPDATED:
          this.$router.push({ name: 'enter-password' });
          break;

        default:
          this.setResponseError('Ошибка изменения пароля');
      }
    },
  },
};
</script>
